
import React, { useCallback } from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Box, Button, Typography, Grid2 } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import PropsTypes from "prop-types";
import { useStyles } from "./style";

const SmartRepair = ({ isNavbarOpen }) => {
  const theme = useTheme();
  const handle = useFullScreenHandle();
  const navigate = useNavigate();

  const classes = useStyles({
    theme,
    isNavbarOpen,
    isSmartRepairExpanded: handle.active,
  });

  const onBackClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const getIframe = useCallback(
    (margin) => {
      return (
        <div
          className={classes.iframeWrapper}
          data-testid={"smartrepair-iframe"}
        >
          <iframe
            style={{
              marginTop: margin,
            }}
            className={classes.iframe}
            src="https://smartrepair.glasswall.advantest.com/"
            title="Smart Repair"
          ></iframe>
        </div>
      );
    },
    [classes.iframe, classes.iframeWrapper]
  );

  return (
    <Box className={classes.wrapper} data-testid={"smart-repair"}>
      <Grid2
        display={"flex"}
        justifyContent={"space-around"}
        className={classes.headerGrid}
      >
        <Box className={classes.titleWrapper}>
          <Typography variant="h5" className={classes.title}>
            Smart Repair
          </Typography>
        </Box>
        <Box className={classes.btnContainer}>
          <Button
            data-testid={"back-btn"}
            className={classes.backBtn}
            variant="contained"
            onClick={onBackClick}
          >
            <ArrowLeftIcon fontSize="small" className={classes.backIcon} />
            Back
          </Button>
          <Button
            data-testid={"expand-btn"}
            sx={{ m: 0, p: 0, minWidth: 40 }}
            size="small"
            variant="contained"
            className={classes.expandIcon}
            onClick={() => {
              handle.active ? handle.exit() : handle.enter();
            }}
          >
            <AspectRatioIcon fontSize="small" />
          </Button>
        </Box>
      </Grid2>
      <FullScreen handle={handle}>{getIframe("0")}</FullScreen>
    </Box>
  );
};

SmartRepair.propTypes = {
  isNavbarOpen: PropsTypes.bool,
};

export default SmartRepair;